import classNames from "classnames";
import { BasicTable } from "../../../atoms/BasicTable";
import { Typography } from "../../../atoms/Typography";
import { Label } from "../../../atoms/Label";
import "./appeal-table.scss";

interface TestData {
  homeWorkName: string;
  dueDate: string;
  completedOn: string;
  status: string;
}

export const AppealTable = () => {
  const data: TestData[] = [
    {
      homeWorkName: "FSQ Drill: Biochemistry I - Biomolecules and Enzymes",
      dueDate: "MM/DD/YY 00:00",
      completedOn: "Not Completed",
      status: "Past Due",
    },
    {
      homeWorkName: "MCAT Biology Passage 3 - Enzymes III",
      dueDate: "MM/DD/YY 00:00",
      completedOn: "Not Completed",
      status: "Incomplete",
    },
    {
      homeWorkName: "MCAT Biology Passage 78 - Enzymes IV",
      dueDate: "MM/DD/YY 00:00",
      completedOn: "MM/DD/YY 00:00",
      status: "Late",
    },
  ];

  return (
    <BasicTable
      rules="none"
      columns={[
        { title: "Homework Name", key: "homeWorkName" },
        { title: "Due Date", key: "dueDate" },
        { title: "Date Completed", key: "completedOn" },
        { title: "Status", key: "status" },
      ]}
      data={data}
      renderHead={(customColumns) => (
        <thead className={classNames("appeal-thead")}>
          <tr>
            {customColumns.map((obj, index) => (
              <th key={index + obj.title}>
                <Typography variant="h7Bold" label={obj.title} />
              </th>
            ))}
          </tr>
        </thead>
      )}
      renderBody={(customData) => (
        <tbody className={classNames("appeal-tbody")}>
          {customData.map((obj, index) => (
            <tr key={index}
              className={classNames({
                "odd-row": index % 2 !== 0,
                "even-row": index % 2 === 0
              })}
            >
              {Object.keys(obj).map((columnName, innerIndex) => (
                <td
                  key={innerIndex + columnName}
                  className={classNames({
                    "homework-name": columnName === "homeWorkName",
                  })}
                >
                  {columnName === "status" ? (
                    <div className={classNames("status-wrapper")}>
                      <Label
                        backgroundColor="red"
                        label={obj[columnName as keyof TestData]}
                      />
                      {obj[columnName as keyof TestData] !== "Late" ? (
                        <Typography
                          label="*Must be completed before appealing"
                          variant="h9Medium"
                        />
                      ) : null}
                    </div>
                  ) : (
                    obj[columnName as keyof TestData]
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      )}
    />
  );
};
